// @ts-nocheck

import React, {useCallback, useEffect, useState} from "react";
import AsyncSelect from "react-select/async";
import {Department} from "../../api/platform/departments";
import {useDepartment, useDepartmentApi} from "../../api/platform/useDepartments";
import {reactSelectClassNames, reactSelectStyles} from "../react-select/styling";
import {ClassNamesConfig, StylesConfig} from "react-select"
import {noop} from "../misc/noop";


type Option = {
    id: string;
    label: string;
    department: Department;
}


type DepartmentSelectV2Props = {
    label?: string;
    rpp?: number
    clientID?: string | null | undefined
    initialID?: string | null | undefined
    onChange?: (selected: Department | undefined) => void
    isDisabled?: boolean
    error?: string | null
    required?: boolean
}



export const DepartmentSelectV2 = ({
                                       rpp = 20,
                                       clientID = null,
                                       initialID = null,
                                       onChange = noop,
                                       isDisabled = false,
                                       label = null,
                                       error = null,
                                       required = false,
                                   }: DepartmentSelectV2Props) => {

    const deptApi = useDepartmentApi();

    const {data: department, isLoading} = useDepartment(initialID ?? "")

    const [selected, setSelected] = useState<Option | null>(null)


    useEffect(() => {
        if (isLoading) return
        if (!initialID) return
        if (department) {
            setSelected({
                id: department.id,
                label: department.name,
                department: department
            })
        }
    }, [department, isLoading, initialID])


    const onSelect = useCallback((option?: Option | null) => {
        if (option) {
            setSelected(option)
            onChange(option.department)
            return
        }
        setSelected(null)
        onChange(undefined)
    }, [onChange, selected]);


    const promiseOptions = useCallback(async (search: string) => {
        const [results, err] = await deptApi.list({clientID: clientID ?? "", search, limit: rpp});
        if (err || !results) return [];
        return results.items.map((d) => ({
            label: d.name,
            value: d.id,
            department: d,
        }))
    }, [deptApi, rpp, clientID]);

    if (isLoading) {
        return null
    }

    const classNames: ClassNamesConfig<Option> = {
        ...reactSelectClassNames as ClassNamesConfig<Option>,
        control: (state) => {
            const base = (reactSelectClassNames as ClassNamesConfig<Option>).control?.(state) ?? ""
            return error ? `${base} outline outline-2 outline-red -outline-offset-2` : base
        },
    }

    if (label){
        return (
            <div className="flex flex-col">
                <label className={`mb-1${error ? " text-red" : ""}`}>{label}{required && <span className="text-dark-red"> *</span>}</label>
                <AsyncSelect<Option> classNames={classNames}
                                     styles={reactSelectStyles as StylesConfig<Option>}
                                     placeholder="Select Department"
                                     value={selected}
                                     onChange={onSelect}
                                     cacheOptions defaultOptions loadOptions={promiseOptions} isClearable/>
            </div>
        )
    }

    return (
        <AsyncSelect<Option> classNames={classNames}
                     styles={reactSelectStyles as StylesConfig<Option>}
                     placeholder="Select Department"
                     value={selected}
                     onChange={onSelect}
                     isDisabled={isDisabled}
                     cacheOptions defaultOptions loadOptions={promiseOptions} isClearable/>
    )
};
